/* global $ */
/* eslint no-bitwise: 0 */
/* eslint-disable */

const generateUniqueId = () =>
  [...Array(10)].map(() => (~~(Math.random() * 36)).toString(36)).join('');

const uniqueId = generateUniqueId();

const $slider = $.$body.find('.image-slider');

$slider.slick({
  // https://github.com/kenwheeler/slick/#settings
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  fade: true,
  // adaptiveHeight: true,
  accessibility: true,
  // focusOnChange: true,
  // ^ prefer using a custom afterChange callback to focus that takes sticky header into account
  prevArrow: `<div class="slick-arrow slick-prev"><svg viewBox="0 0 23 34" fill="none" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" aria-labelledby="left-chevron-small-title-${uniqueId} left-chevron-small-desc-${uniqueId}"><title id="left-chevron-small-left-title-${uniqueId}">Left Arrow</title><desc id="left-chevron-small-desc-left-${uniqueId}">An arrow pointing left</desc><path d="M17.0549 33.4567L22.1461 28.3218L10.6433 17.2792L21.87 5.95598L16.6536 0.948291L0.335776 17.4064L17.0549 33.4567Z" fill="currentColor"/></svg></div>`,
  nextArrow: `<div class="slick-arrow slick-next"><svg viewBox="0 0 23 34" fill="none" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" aria-labelledby="left-chevron-small-title-${uniqueId} left-chevron-small-desc-${uniqueId}"><title id="left-chevron-small-right-title-${uniqueId}">Right Arrow</title><desc id="left-chevron-small-desc-right-${uniqueId}">An arrow pointing right</desc><path d="M5.55742 0.338867L0.403259 5.41056L11.7688 16.5943L0.403259 27.778L5.55742 32.8497L22.0772 16.5943L5.55742 0.338867Z" fill="currentColor"/></svg></div>`,
});

/**
 * Advanced slider control.
 */
const sizeMove = 352;

$.$body.on('click', '.slider-control', (e) => {
  const $target = $(e.currentTarget);
  const $advSlider = $target
    .next('.slider__outer-container')
    .find('.slider__container');
  const left = $advSlider.scrollLeft();
  const width = $advSlider.innerWidth();
  const isFar = width - left < sizeMove * 2 - 2;
  console.log(left, width, { isFar });
  $advSlider.animate({ scrollLeft: left + sizeMove }, 800);
  if (isFar) {
    $target.parent().addClass('too-far');
  } else {
    $target.parent().removeClass('too-far');
  }
});
